import {getMethod} from '~/api'

async function get() {
    return await getMethod('/api/hotelExtraServicesDictionaryInfo')
}

export {get}
